/**
 * TanStack Query hooks for `google-ads-gclid-capture`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	googleAdsGclidCaptureQueryKeys,
	type CreateGoogleAdsGclidCaptureBody,
	type ListGoogleAdsGclidCaptureResponse,
	type GoogleAdsGclidCaptureRow,
} from "./api";

export function useGoogleAdsGclidCaptureList(): UseQueryResult<ListGoogleAdsGclidCaptureResponse, Error> {
	return useQuery({
		queryKey: googleAdsGclidCaptureQueryKeys.list(),
		queryFn: list,
	});
}

export function useGoogleAdsGclidCaptureCreate(): UseMutationResult<GoogleAdsGclidCaptureRow, Error, CreateGoogleAdsGclidCaptureBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: googleAdsGclidCaptureQueryKeys.all });
		},
	});
}

export function useGoogleAdsGclidCaptureDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: googleAdsGclidCaptureQueryKeys.all });
		},
	});
}
